import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataVersion(params) {
	return client.get("api/ecommerce/mobile-version/data", {
		params: params,
	});
}

function updateVersion(params) {
	return client.post("api/ecommerce/mobile-version/update", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDataVersion,
	updateVersion,
}